import UpdateTagRequestModelBase from '../_generated/modelBases/update-tag-request-model-base';

export default class UpdateTagRequestModel extends UpdateTagRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
